import PageLayout from "@/pages/home/components/PageLayout";
import PriceSection from "@/pages/home/components/PriceSection";

export default function PricePage() {
  return (
    <PageLayout>
      <PriceSection />
    </PageLayout>
  );
}
